// extracted by mini-css-extract-plugin
module.exports = {"body":"public-payment-terms_body__UEj2i","spinner":"public-payment-terms_spinner__tsIo8","spin":"public-payment-terms_spin__T04eF"};